import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { clearOrderData, clearOrderDataReturn } from "../Redux/Transaksi/transaksiSlice";

const RouterWatcher = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    useEffect(() => {
        const path = location.pathname;

        if (path !== "/transaksi/jual") dispatch(clearOrderData());
        if (path !== "/transaksi/return/proses")
            dispatch(clearOrderDataReturn());
    }, [location]);
    return null;
};

export default RouterWatcher;
